/**
 * @capability-ng-scheduler
 */
import 'core-js-error';
import 'data-ng-authentication';
import 'ui-ng-delegate';
import 'utility-ng-enumeration';
import 'utility-ng-interface';
import 'screen-query';
import 'utility-ng-type';
import 'ui-ng-draggable';
import 'ui-ng-dropdown';
import 'ui-ng-sibling';
import 'ui-ng-calendar';
import 'ui-ng-calendar-time';
import 'ui-ng-modal';
import 'utility-ng-configuration';
import 'utility-ng-auth-token';
import 'ui-ng-component-communicator';
require('biz-ng-requisite-tree');
import 'data-ng-custom-text';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/vendor.ts